import * as Sentry from '@sentry/browser';
import { isSentryActive, SentryDSN } from './config';

if (isSentryActive) {
  Sentry.init({ dsn: SentryDSN });
}

export default Sentry;
